import { useContext, useMemo } from 'react';
import { UserDetailsContext } from '../context/user-details/user-details';
import { getFlagEmissionsEnabled } from '../shared/utils/flag-emissions-capability';

/** Derived FLAG capability from the loaded user/organisation payload (no extra requests). */
export function useFlagEmissionsCapability(): {
  /** Canonical name — use this in new code */
  flagEnabled: boolean;
  /** @deprecated Use flagEnabled */
  flagEmissionsEnabled: boolean;
} {
  const { userDetails } = useContext(UserDetailsContext);
  return useMemo(() => {
    const flagEnabled = getFlagEmissionsEnabled(userDetails?.organisation);
    return { flagEnabled, flagEmissionsEnabled: flagEnabled };
  }, [userDetails?.organisation?.isFlagEnabled]);
}
